import { render, staticRenderFns } from "./advisor.vue?vue&type=template&id=3e438434&scoped=true&"
import script from "./advisor.vue?vue&type=script&lang=js&"
export * from "./advisor.vue?vue&type=script&lang=js&"
import style0 from "./advisor.vue?vue&type=style&index=0&id=3e438434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e438434",
  null
  
)

export default component.exports